import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";

export const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      if (res.status === "already_subscribed") toast.info(res.message);
      else toast.success(res.message);
      setEmail("");
    } catch {
      toast.error("Subscription failed. Please check your email and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="join" className="max-w-7xl mx-auto px-4 sm:px-8 mt-24 scroll-mt-24">
      <div className="relative bg-slate-900 rounded-2xl p-10 md:p-16 overflow-hidden">
        <div className="noise-overlay" />
        <div className="relative max-w-2xl">
          <p className="uppercase text-xs tracking-[0.2em] font-semibold text-emerald-400 mb-4">Join Social Flats — Free</p>
          <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-white mb-4">Get in. Get ads. Get paid.</h2>
          <p className="text-slate-400 text-base mb-8 leading-relaxed">Drop your email to join free and get weekly intel: new programs, commission changes and earning opportunities across all 10 niches.</p>
          <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              data-testid="newsletter-email-input"
              className="flex-1 px-5 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-button"
              className="flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-emerald-600 text-white font-medium hover:bg-emerald-500 transition-colors duration-200 disabled:opacity-60"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
